<!--title -->
<app-modal-title
  [isShowClose]="true"
  (isCloseModal)="onClose(null)"
></app-modal-title>

<!---------------------------------------------------------------  btns ---------------->
<div class="card-toolbar tw-mt-3" before-btns>
  <!-- upload file btn -->
  <button
    (click)="onUploadFile()"
    class="btn btn-light txt-lg button-shadow tw-mx-1 btn-hover-rise"
    type="button"
    mat-ripple
  >
    <i class="mdi mdi-upload mdi-20px tw-text-gray-700 tw-cursor-pointer"></i>
    <span class="tw-text-gray-700">
      {{ "common.uploadFile" | translate }}
    </span>
  </button>
</div>
<form [formGroup]="form" autocomplete="off" *ngIf="!loading">
  <section class="tw-m-[20px]">
    <h5
      class="tw-text-right tw-pb-[15px] tw-text-base tw-text-gray-700 border-bottom border-secondary"
    >
      {{ "messages.selectFileFromFileManager" | translate }}
    </h5>

    <div class="files-container">
      <div class="tw-flex flex-wrap tw-items-center">
        <div class="files" *ngFor="let fileType of files">
          <div *ngFor="let file of fileType">
            <div
              *ngIf="file"
              [ngClass]="
                (file | fileType) == 'image' ? 'img-item' : 'file-item'
              "
            >
              <img
                (click)="selectFile(file)"
                [src]="
                  (file | fileType) == 'image'
                    ? url + '/' + file
                    : (file | fileType) == 'video'
                    ? '/assets/media/svg/files/mp4.svg'
                    : (file | fileType) == 'pdf'
                    ? '/assets/media/svg/files/pdf.svg'
                    : '/assets/media/svg/files/file.svg'
                "
              />
              <button (click)="showDeleteDialog($event, file)" class="btn">
                {{ "common.delete" | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- empty -->
    <ng-container *ngIf="files?.length == 0">
      <div class="tw-mt-3">
        <div class="tw-w-full">
          <h4 class="tw-text-center tw-text-gray-500 dark:tw-text-gray-300">
            {{ "common.empty" | translate }}
          </h4>
        </div>
      </div>
    </ng-container>
  </section>
</form>
<ng-container *ngIf="loading">
  <span
    class="spinner-border spinner-border-sm"
    role="status"
    aria-hidden="true"
  ></span>
  <span class="sr-only">Loading...</span>
</ng-container>
